<h2
  class="profile-preview__section-title"
  style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;"
  (click)="onToggle()"
>
  <span>
    <span nz-icon [nzType]="iconType" nzTheme="outline"></span>
    {{ titleText }}
  </span>
  <button type="button" nz-button nzType="text" nzSize="large" style="pointer-events: none;">
    <span nz-icon [nzType]="isCollapsed ? 'down' : 'up'" nzTheme="outline" class="section-chevron-icon"></span>
  </button>
</h2>
